module.exports = __webpack_public_path__ + "img/backgr-home-third-section.a64e0e87.png";